import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datePourcentage',
  standalone: true,
})
export class DatePourcentagePipe implements PipeTransform {
  transform(middleDate: Date, startDate: Date, endDate: Date): number {
    if (!startDate || !middleDate || !endDate) {
      throw new Error('Toutes les dates doivent être fournies.');
    }

    // Convertir les dates en timestamp pour effectuer les calculs
    const start = new Date(startDate).getTime();
    const middle = new Date(middleDate).getTime();
    const end = new Date(endDate).getTime();

    if (middle < start || middle > end) {
      throw new Error(
        'La date intermédiaire doit être entre la date de début et la date de fin.'
      );
    }

    const totalInterval = end - start;
    const elapsedInterval = middle - start;

    // Calculer le pourcentage
    return (elapsedInterval / totalInterval) * 100;
  }
}
